import { API } from "./Config";

export async function apiFetch(endpoint, options = {}) {
  const token = localStorage.getItem("token");

  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token}`,
  };

  // Only set JSON content type if the body isn't FormData
  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  const response = await fetch(`${API}${endpoint}`, {
    ...options,
    headers,
  });

  // Public endpoints handle their own authentication errors.
  const publicEndpoints = [
    "/login",
    "/google-login",
    "/session/takeover",
    "/forgot-password",
    "/reset-password"
  ];

  if (
    response.status === 401 &&
    token &&
    !publicEndpoints.includes(endpoint)
  ) {
    // Don't clear a newer session.
    if (localStorage.getItem("token") === token) {
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("userName");
      localStorage.removeItem("whatsappConnected");

      window.location.href = "/";
    }
  }

  return response;
}